import React from 'react'

type PublicPageShellProps = {
  children: React.ReactNode
}

/**
 * Gemensam page-shell för publika undersidor (exkl. hero).
 * Samma bakgrund som HomeShell så att sektioner känns enhetliga med startsidan.
 */
const PublicPageShell: React.FC<PublicPageShellProps> = ({ children }) => {
  return (
    <div className="relative">{children}</div>
  )
}

export default PublicPageShell
